import {defineMessages} from 'react-intl';
import {mergeMap} from '@igp/shared/otel';
import {BaseEpicsBuilder} from '@igp/shared/redux';
import {RealtimeMessageTrigger} from '@igp/shared/redux/realtime';
import {messageActions, realtimeActions} from '@redux';
import {inject, injectable} from 'inversify';
import type {Epic} from 'redux-observable';
import {filter, of} from 'rxjs';
import {isActionOf} from 'typesafe-actions';

import {debtTransferLogActions} from './actions';
import {DebtTransferLogServiceTypes} from './constants';
import type {IDebtTransferLogService} from './service';
import type {DebtTransferLogEntityType} from './types';

export const localized = defineMessages({
    adjustAgentDebtSuccess: {
        id: 'debtTransferLog_adjustAgentDebtSuccess',
        defaultMessage: 'Debt adjusted successfully. Changes will appear in reports within 30 minutes.',
    },
});

@injectable()
export class DebtTransferLogEpicsBuilder extends BaseEpicsBuilder {
    constructor(@inject(DebtTransferLogServiceTypes.service) private readonly _service: IDebtTransferLogService) {
        super();
    }

    buildEpicList(): Epic[] {
        return [this.buildAdjustAgentDebtRequestEpic(), this.buildAdjustAgentDebtSuccessEpic()];
    }
    private buildAdjustAgentDebtRequestEpic(): Epic {
        return this.buildRequestEpic(debtTransferLogActions.adjustAgentDebt, payload => this._service.adjustAgentDebt(payload));
    }

    private buildAdjustAgentDebtSuccessEpic(): Epic {
        return action$ =>
            action$.pipe(
                filter(isActionOf(debtTransferLogActions.adjustAgentDebt.success)),
                mergeMap(() => {
                    return of(
                        realtimeActions.event({
                            entity: 'DebtTransferLog' satisfies DebtTransferLogEntityType,
                            items: [],
                            trigger: {type: RealtimeMessageTrigger.Add},
                        }),
                        messageActions.saveMessage({message: localized.adjustAgentDebtSuccess, mode: 'success'})
                    );
                })
            );
    }
}
